// src/store/index.js  
import Vue from 'vue';  
import Vuex from 'vuex';  

Vue.use(Vuex);  

// 从localStorage中恢复活动ID
const savedActivityId = localStorage.getItem('activityId');
const parsedActivityId = savedActivityId ? parseInt(savedActivityId, 10) : null;

export default new Vuex.Store({  
  state: {  
    badge: 0,  
    activityId: parsedActivityId || null // 全局活动ID，优先使用localStorage中的值  
  },  
  mutations: {  
    increment(state) {  
      state.badge++;  
    },  
    // 设置活动ID并保存到localStorage
    setActivityId(state, id) {  
      state.activityId = id;
      // 保存到localStorage以支持页面刷新后恢复
      if (id) {
        localStorage.setItem('activityId', id);
      } else {
        localStorage.removeItem('activityId');
      }
    }  
  },  
  actions: {  
    updateActivityId({ commit }, id) {  
      commit('setActivityId', id);  
    }  
  },  
  getters: {  
    // 获取活动ID，如果不存在返回null  
    getActivityId: state => state.activityId  
  },  
  modules: {  
    // 如果需要的话，可以在这里定义模块  
  }  
});